import { render, staticRenderFns } from "./PersistUser.vue?vue&type=template&id=c72e64e6&"
import script from "./PersistUser.vue?vue&type=script&lang=js&"
export * from "./PersistUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports